import buttons from '../../styles/buttons.module.css';
import { v4 } from 'uuid';
import { useState, useContext } from 'react';
import { Button } from '@material-ui/core';
import { getURLForCustomArtwork } from '../../utils/getArtworkUrl';
import submitImageToStorage from '../../utils/submitImageToStorage';
import getSnapshotOfState from '../../utils/getSnapshotOfState';
import { uploadStateToCloud } from '../../reducers/store_state/StoreStateSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { PreviewDataContext } from '../../context/PreviewContext';
export const SaveDesignButton = ({ setDesignURL, setModalVisible }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { preview } = useContext(PreviewDataContext);
    const artworkState = useSelector((state) => state.rootReducer.currentArtwork);
    const [saveDesignText, setSaveDesignText] = useState(t('summary.save_design'));
    const currState = useSelector((state) => state.rootReducer);
    const handleSaveDesign = async () => {
        setSaveDesignText(t('summary.save_desing_uploading'));
        const folderName = v4();
        let storedImagesObject = await getURLForCustomArtwork(artworkState, folderName);
        storedImagesObject['preview'] = await submitImageToStorage(folderName, preview, 'preview');
        const stateSnapshot = getSnapshotOfState(currState, storedImagesObject);
        dispatch(uploadStateToCloud(JSON.stringify(stateSnapshot)))
            .then(unwrapResult)
            .then((result) => {
                console.log(result);
                setSaveDesignText(t('summary.save_desing_uploaded'));
                let url = window.location.href;
                let link = new URL(url);
                if (url.indexOf('configid') > -1) {
                    link.searchParams.set('configid', result.id);
                    setDesignURL(`${link}`);
                } else {
                    setDesignURL(`${link.origin}/pages/saved-design?configid=${result.id}`);
                }
                setModalVisible(true);
            });
    };

    return (
        <Button
            disableRipple={true}
            className={buttons.btnPill + ' ' + buttons.btnSaveDesign}
            onClick={() => handleSaveDesign()}>
            {saveDesignText}
        </Button>
    );
};
